import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {Popover} from "@material-ui/core";
import TextField from "@material-ui/core/TextField/TextField";
import MaterialUISelect from "../../../common/selects/MaterialUISelect";
import ActionPopover from "../../../common/popovers/ActionPopover";
import {replaceOffers} from "../../../../actions/managerOfferActions";

export default function OffersToolsPopover  ({button, item, loadTableData}) {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    const dispatch = useDispatch();
    const {parentOffers} = useSelector(state => state.filterDataReducer.filterData);

    const [editableCapItem, setEditableCapItem] = useState({});
    const [selectedOffer, setSelectedOffer] = useState(null);


    useEffect(() => {
        if (!item || !anchorEl) {
            return;
        }
        setEditableCapItem(item);
    }, [item, anchorEl]);



    const handleClick = (e) => {
        setAnchorEl(e.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const replace = () => {
        const body = [];
        const uids = [];

        item.offerLinks.forEach(offerLink => {
            const uid = item.externalPartnerId + "_" + offerLink.offerId + "_" + offerLink.billingType + "_" + selectedOffer.id;
            if (!uids.includes(uid)) {
                uids.push(uid);
                body.push({partnerId: item.externalPartnerId, oldOfferId: offerLink.offerId, offerBillingType: offerLink.billingType, newOfferId: selectedOffer.id})
            }
        });
        dispatch(replaceOffers(body, () => loadTableData()));
        handleClose();
    };

    const popover = () => {
        return (
            <Popover id={id}
                     open={open}
                     anchorEl={anchorEl}
                     onClose={handleClose}
                     anchorOrigin={{
                         vertical: 'bottom',
                         horizontal: 'right',
                     }}
                     transformOrigin={{
                         vertical: 'top',
                         horizontal: 'right',
                     }}
            >
                <div style={{padding: "10px", textAlign: "center"}}>
                    {"Заменить оффер"}
                </div>
                <div style={{padding: "10px", minWidth: "305px", maxWidth: "500px", maxHeight: "90vh", overflowY: "auto"}}>
                    <TextField label="Партнёр"
                               name="partnerName"
                               value={editableCapItem?.partnerName || ""}
                               disabled
                               InputLabelProps={{shrink: true}}
                               style={{width: '100%', paddingBottom: '15px'}}
                    />
                    <TextField label="Текущий оффер"
                               name="offer"
                               value={(editableCapItem?.parentOfferId  + " | " + editableCapItem?.parentOfferName)}
                               disabled
                               InputLabelProps={{shrink: true}}
                               style={{width: '100%', paddingBottom: '15px'}}
                    />
                    <MaterialUISelect
                        dropdownData={parentOffers}
                        selectedValue={selectedOffer}
                        displayedFields={["id", "offerName"]}
                        dataField='id'
                        label='Новый оффер'
                        onSelectCallbackFunction={setSelectedOffer}
                        isSearchable/>

                    <br/>
                    <br/>
                    <br/>
                    <br/>
                    <div style={{width: "100%"}}>
                        <div className="circle-btn-group" >
                            <ActionPopover
                                button={<button className="circle-btn" title="Заменить оффер"><i className="ti ti-save"/></button>}
                                popoverLocation='top'
                                label={<><div>{"Заменить оффер?"}</div><div>{" Трафик партнера для выбранных ссылок пойдет на новый оффер."}</div></>}
                                handleSubmit={replace}
                            />

                            <button className="circle-btn" title="Отменить"><i className="ti ti-close" onClick={handleClose}/>
                            </button>
                        </div>
                    </div>
                </div>
            </Popover>
        )
    };

    return (
        <>
            <div className="" onClick={handleClick}>
                {button}
            </div>
            {anchorEl && popover()}
        </>
    );}